/**
 * Pratica shared schemas — F-003.4 Phase 3 (IMPL-P3-001).
 *
 * Schemi Zod condivisi tra API e frontend per la registrazione contratti.
 * Per ora contiene solo lo schema del body di `POST /api/v1/pratiche/:id/submit`
 * usato sia dalla route Express sia dal client (`pratica-client.ts`) per garantire
 * type safety end-to-end.
 *
 * Pattern di riferimento: `packages/shared/src/schemas/contract.ts`
 *  - named export dello schema + `z.infer<typeof schema>` per il tipo.
 *  - nessuna dipendenza da side-effects (db, fetch, env): puro contratto dati.
 */
import { z } from 'zod';
/**
 * Body atteso da `POST /api/v1/pratiche/:id/submit`.
 *
 * Campi:
 *  - `consentGiven`: literal `true` — la submit si rifiuta se il client non
 *    invia `true` esplicitamente (defense in depth: previene submit accidentali
 *    senza spunta di consenso esplicita).
 *  - `consentTextHash`: hash del testo di consenso visualizzato all'utente
 *    (SHA-256 hex = 64 chars, oppure base64url = ~86 chars). Memorizzato
 *    nell'audit log per provare *quale versione* del testo è stata accettata
 *    (immutable evidence — il testo originale può evolvere, l'hash resta
 *    legato al record audit).
 */
export const submitPraticaBodySchema = z.object({
    consentGiven: z.literal(true),
    consentTextHash: z
        .string()
        .min(64, { message: 'consentTextHash troppo corto (atteso SHA-256 hex o base64url)' })
        .max(128, { message: 'consentTextHash troppo lungo' }),
});
//# sourceMappingURL=pratica.js.map